export default "__VITE_ASSET__Czok8sBb__"